import { render } from "./EigentuemerInformationen.vue?vue&type=template&id=77f26e70"
import script from "./EigentuemerInformationen.vue?vue&type=script&lang=js"
export * from "./EigentuemerInformationen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__